import { render } from "./stronaPodgladu.vue?vue&type=template&id=36ec1229&scoped=true"
import script from "./stronaPodgladu.vue?vue&type=script&lang=js"
export * from "./stronaPodgladu.vue?vue&type=script&lang=js"

import "./stronaPodgladu.vue?vue&type=style&index=0&id=36ec1229&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ec1229"]])

export default __exports__